/* eslint-env es2023 */
function getCookieByNameOb(name) {
  function escape(s) {
    return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1')
  }
  var match = document.cookie.match(
    RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)')
  )
  return match ? match[1] : null
}

function setCookieOb(cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function updateLocalizationOb({ country, language }) {
  const formId = crypto.randomUUID()
  // Return the buyer to the SAME page (path + query) in the market we switch
  // them into, rather than the market homepage. Without this, coming back from
  // an external round-trip (Typeform coach quiz -> /pages/truecoach?response_id=,
  // or the checkout logo) would drop them on "/en-ca/" and lose the query.
  // Strip any leading locale/market segment so Shopify does not double-prefix
  // when it re-localizes return_to into the selected market.
  const returnTo =
    (window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') ||
      '/') + window.location.search
  const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT">
        <input name="country_code" value="${country}">
        <input name="language_code" value="${language}">
        <input name="return_to" value="${returnTo}">
      </form>
    `
  document.body.insertAdjacentHTML('beforeend', formHtml)
  document.getElementById(formId).submit()
}

async function detectObCountry() {
  if (window.Shopify.designMode) {
    console.log('[OB] Design mode detected, skipping country detection')
    return
  }

  console.log('[OB] Detecting Country')

  const obCountryDetectionCookieName = 'ob-localization'

  try {
    const localizationCountry = getCookieByNameOb(obCountryDetectionCookieName)

    console.log(
      '[OB] Detected Cookie: ',
      localizationCountry || 'No cookie detected'
    )

    // Already in the market we detected the buyer into — nothing to do.
    if (localizationCountry && localizationCountry === window.Shopify.country) {
      return
    }

    // We have a valid saved market that differs from the active one. This is
    // the "returned from checkout" case: Shopify's checkout logo links to the
    // bare primary-market root ('/'), dropping a CA buyer back onto US. Restore
    // their market without re-hitting IP detection so the market stays sticky.
    // (Legacy cookies stored the literal 'true'; those fail this test and fall
    // through to fresh detection below, which rewrites the cookie as a code.)
    if (/^[A-Za-z]{2}$/.test(localizationCountry || '')) {
      console.log('[OB] Restoring saved market: ', localizationCountry)
      updateLocalizationOb({
        country: localizationCountry,
        language: window.Shopify.locale,
      })
      return
    }

    // Market root from the single server-written source (window.eHS.root), as a
    // trailing-slashed prefix to match Shopify.routes.root ("/" or "/en-ca/").
    // Not routed through buildUrl() because the literal [] in the query must not
    // be percent-encoded.
    const marketRoot = ((window.eHS && window.eHS.root) || '/').replace(/\/?$/, '/')
    const shopifyDetectResponse = await fetch(
      marketRoot +
        'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.language}`
    ).then(r => r.json())

    const suggestedCountry =
      shopifyDetectResponse.detected_values?.country?.handle
    const suggestedLanguage =
      shopifyDetectResponse.suggestions?.[0]?.parts?.language?.handle ||
      window.Shopify.locale

    if (!suggestedCountry || !suggestedLanguage) {
      return
    }

    console.log(
      '[OB] Suggested Country and Language: ',
      suggestedCountry,
      suggestedLanguage
    )
    setCookieOb(obCountryDetectionCookieName, suggestedCountry, 365)

    if (suggestedCountry != window.Shopify.country) {
      updateLocalizationOb({
        country: suggestedCountry,
        language: suggestedLanguage,
      })
    }
  } catch (error) {
    console.error('Error fetching user country: ', error)
  }
}